import { render, staticRenderFns } from "./WalkieTalkie.vue?vue&type=template&id=05a9c2b0&scoped=true&"
import script from "./WalkieTalkie.vue?vue&type=script&lang=js&"
export * from "./WalkieTalkie.vue?vue&type=script&lang=js&"
import style0 from "./WalkieTalkie.vue?vue&type=style&index=0&id=05a9c2b0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a9c2b0",
  null
  
)

export default component.exports